export default "__VITE_ASSET__BQD_JVCX__"